import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EventCreationPage from '../pages/v2/EventCreationPage';
import EventDetailsV2 from '../pages/v2/EventDetailsV2';
import PublicRegistrationForm from '../pages/v2/PublicRegistrationForm';
import EventsListV2 from '../pages/v2/EventListV2';
import EventScanPageV2 from '../pages/v2/EventScanPageV2';
import EventDashboardV2 from '../pages/v2/EventDashboardV2';

const V2Routes = () => {
    return (
        <Routes>
            <Route path="/" element={<EventsListV2 />} />
            <Route path="/create" element={<EventCreationPage />} />
            <Route path="/scan" element={<EventScanPageV2 />} />
            <Route path="/dashboard" element={<EventDashboardV2 />} />
            <Route path="/:eventId" element={<EventDetailsV2 />} />
            <Route path="/:eventId/edit" element={<EventCreationPage />} />
        </Routes>
    );
};

// Public route (outside /v2/events) - Add this to your main AppRoutes
export const PublicRoutes = () => {
    return (
        <Routes>
            <Route path="/register/:tokenOrId" element={<PublicRegistrationForm />} />
        </Routes>
    );
};

export default V2Routes;